import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5rem;
  }

  .row-left {
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6rem;
    margin-bottom: 1rem;

    .h-descricao {
      font-size: 0.7125rem;
      line-height: 0.8rem;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    margin-left: 1rem;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.8rem;
    margin-bottom: 0.5rem;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6rem; margin-bottom: 0rem;`}
  }

  .novo-horario {
    cursor: pointer;
    padding: 0 1.7rem;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 2rem;
    width: 8rem;
    background-color: ${Colors.Color4};
    border: 0.25rem solid ${Colors.Color4};
    border-radius: 0.5rem;
    margin-right: 0.6rem;

    .adiciona-horario {
      font-size: 0.88rem;
      font-weight: 500;
      color: ${Colors.Color13};
    }
  }

  .footer {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    border-radius: 0.8rem;
    background: #242424;
    margin-bottom: 1.5rem;
    padding: 0rem 1rem 0rem 1rem !important;

    .content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4rem;
        padding: 0.2rem 0.6rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75rem;
        margin-bottom: 1.25rem;

        .cod {
          font-size: 0.75rem;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }

  .atv-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
    margin-bottom: 0.5rem;
    border-radius: 0.4rem;

    .atv-content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: ${Colors.Color23};
      border-radius: 0.4rem;
      padding: 0.5rem 1rem 0.5rem 1rem;

      .card-titulo {
        border-radius: 0.4rem;
        padding: 0.2rem 0.6rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        .titulo {
          font-size: 0.75rem;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }

      .card-check {
        cursor: pointer;
        width: 1.5rem;
        height: 1.5rem;
        background: ${Colors.Color13};
        border-radius: 0.4rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .checked {
        span {
          width: 1rem;
          height: 1rem;
          background: ${Colors.Color4};
          display: block;
          border-radius: 0.3rem;
        }
      }
    }

    .atv-content-body {
      margin-top: 0.5rem;

      .col {
        margin-bottom: 0.5rem !important;
      }
    }
  }
`;
